// extracted by mini-css-extract-plugin
module.exports = {"container":"TabApiService_container__2AuEC","alignButtonRight":"TabApiService_alignButtonRight__1EL5I","apiToken":"TabApiService_apiToken__2P95S"};